import React, { useState, useEffect } from 'react'
// import '../index.css'
import LogoWhite from '../../assets/images/LogoWhite.png'
import FooterGirl from '../../assets/images/FooterGirl.png'
import FooterMan from '../../assets/images/FooterMan.png'
import { Link, NavLink } from 'react-router'
import { Button } from 'components/UI'
// import Modal from "../Components/Modal";

const LandingFooter = () => {
  const [modalData, setModalData] = useState({ isOpen: false, type: '' })
  // Local state for the switch: 'student' or 'tutor'
  const [activeRole, setActiveRole] = useState('student')

  // Tracks whether the screen is 560px or less
  const [isMobile, setIsMobile] = useState(false)

  // On mount & resize, check screen width
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1230)
    }
    // Check initially
    handleResize()
    // Listen for changes
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const handleModalOpen = (type) => {
    setModalData({ isOpen: true, type })
  }

  const handleModalClose = () => {
    setModalData({ isOpen: false, type: '' })
  }

  // Renders either the two side-by-side cards (desktop)
  // or the switch layout (mobile)
  const renderStudentTutorSection = () => {
    if (!isMobile) {
      // ---------- DESKTOP LAYOUT ----------
      return (
        <div className="flex justify-center items-stretch gap-12 mb-40">
          <div className="w-[350px]  bg-black/0 rounded-3xl p-8 flex flex-col gap-8 text-center shadow-black border !border-gray-50/30  hover:translate-y-2 hover:shadow-2xl transition-all duration-300">
            <div className="h-[306px] bg-[rgba(255,255,255,0.3)] rounded-3xl px-4 pt-4 pb-3 flex items-center justify-center opacity-100">
              <div className="h-[237px] w-full bg-[#f79009] rounded-2xl flex items-center  justify-center  relative  opacity-100">
                <img
                  src={FooterGirl}
                  alt="Student"
                  className="h-[265px] absolute bottom-0 z-40  opacity-100 object-cover rounded-lg"
                />
              </div>
            </div>
            <p className="text-justify font-normal text-[#FDFDFD] mb-4">
              Start learning the most in-demand skills in the crypto-world. Learn at your own pace
              with the help of our collaborative tools!
            </p>
            <Link to="/student/register">
              <Button onClick={() => handleModalOpen('Student')} className="w-full mt-auto">
                Become a Student
              </Button>
            </Link>
          </div>

          <div className="w-[350px] bg-black/0 rounded-3xl p-8 flex flex-col gap-8 text-center shadow-black border !border-gray-50/30  hover:translate-y-2 hover:shadow-2xl transition-all duration-300">
            <div className="h-[306px] bg-[rgba(255,255,255,0.3)] rounded-3xl px-4 pt-4 pb-3 flex items-center justify-center opacity-100">
              <div className="h-[237px] w-full bg-[#f79009] rounded-2xl flex items-center  justify-center  relative  opacity-100">
                <img
                  src={FooterMan}
                  alt="Tutor"
                  className="h-[265px] absolute bottom-0 z-40  opacity-100 object-cover rounded-lg"
                />
              </div>
            </div>
            {/* <h3 className="Footer-Card-Title">Become a Tutor</h3> */}
            <p className="text-justify font-normal text-[#FDFDFD] mb-4">
              Start teaching your skills to students all over the world. Enjoy flexible hours and
              get the most out of your work!
            </p>
            <Link to="/tutor/register">
              <Button
                onClick={() => handleModalOpen('Tutor')}
                className="cta-button-footer w-full mt-auto"
              >
                Become a Tutor
              </Button>
            </Link>
          </div>
        </div>
      )
    } else {
      // ---------- MOBILE LAYOUT (≤560px) ----------
      return (
        <div className="Footer-Switch-Container">
          {/* Switch Buttons */}
          <div className="Footer-Switch-Buttons">
            {/* <Link to="/student/register"> */}
            <button
              className={`Footer-Switch-Btn ${activeRole === 'student' ? 'active' : ''}`}
              onClick={() => setActiveRole('student')}
            >
              Become a Student
            </button>
            {/* </Link> */}

            {/* <Link to="/tutor/register"> */}
            <button
              className={`Footer-Switch-Btn ${activeRole === 'tutor' ? 'active' : ''}`}
              onClick={() => setActiveRole('tutor')}
            >
              Become a Tutor
            </button>
            {/* </Link> */}
          </div>

          {/* Switch Content */}
          {activeRole === 'student' ? (
            <div className="w-full flex justify-center">
              <div className=" w-64 min-h-[530px] bg-[rgba(255, 255, 255, 0)] border border-white/30 rounded-3xl py-4 p-8 flex-col gap-8  text-center shadow-black backdrop-blur-sm   transition-all duration-300">
                <div className="w-full h-[306px] bg-[rgba(255, 255, 255, 0.3)] rounded-3xl px-2 py-5 flex items-center justify-center opacity-100">
                  <div className="w-full h-[241px] bg-[#f79009] rounded-2xl p-2.5 flex items-center  justify-center  relative  opacity-100">
                    <img
                      src={FooterGirl}
                      alt="Student"
                      className="w-full object-cover h-[260px] rounded-lg relative -top-4 opacity-100"
                    />
                  </div>
                </div>
                {/* <h3 className="Footer-Card-Title">Become a Student</h3> */}
                <p className="Footer-Card-Description">
                  Start learning the most in-demand skills in the crypto-world. Learn at your own
                  pace with the help of our collaborative tools!
                </p>
                <Button onClick={() => handleModalOpen('Student')} className="mt-4 w-full">
                  Become a Student
                </Button>
              </div>
            </div>
          ) : (
            <div className="w-full flex justify-center">
              <div className=" w-64 min-h-[530px] bg-[rgba(255, 255, 255, 0)] border border-white/30 rounded-3xl py-4 p-8 flex-col gap-8  text-center shadow-black backdrop-blur-sm   transition-all duration-300">
                <div className="w-full h-[306px] bg-[rgba(255, 255, 255, 0.3)] rounded-3xl px-2 py-5 flex items-center justify-center opacity-100">
                  <div className="w-full h-[241px] bg-[#f79009] rounded-2xl p-2.5 flex items-center  justify-center  relative  opacity-100">
                    <img
                      src={FooterMan}
                      alt="Tutor"
                      className="w-full h-[260px] object-cover rounded-lg relative -top-4 opacity-100"
                    />
                  </div>
                </div>
                {/* <h3 className="Footer-Card-Title">Become a Tutor</h3> */}
                <p className="Footer-Card-Description">
                  Start teaching your skills to students all over the world. Enjoy flexible hours
                  and get the most out of your work!
                </p>
                <Button onClick={() => handleModalOpen('Tutor')} className="w-full mt-4">
                  Become a Tutor
                </Button>
              </div>
            </div>
          )}
        </div>
      )
    }
  }

  return (
    <footer className="Footer text-white py-12 px-5">
      <div className="Footer-Container ">
        <h2
          className="Footer-Title  font-family: 'Inter', sans-serif;
  font-semibold text-3xl leading-9   text-center  text-white  mb-5  opacity-100"
        >
          Start Learning Crypto with Us
        </h2>

        {/* Render either Desktop or Mobile layout */}
        {renderStudentTutorSection()}

        {/* Footer Brand + Links (same for both) */}
        <div className="Footer-Container  max-w-7xl mx-auto px-6 py-10 rounded-2xl flex flex-col md:flex-row justify-between items-center md:items-start">
          <div className="Footer-Brand">
            <img src="logo.png" alt="Apolo Logo" className="Footer-Logo aspect-[179/49]" />
            <p className="mt-3">© {new Date().getFullYear()} All rights reserved.</p>
          </div>

          <div className="Footer-Links">
            <div className="Footer-Section">
              <h5 className="Footer-Section-Title underline">Company</h5>
              <ul className="Footer-Section-List">
                <li className="Footer-Section-Item">Tutors</li>
                <li className="Footer-Section-Item">Job Posts</li>
                <li
                // className="Footer-Section-Item"
                // onClick={() => {
                //   window.location.href = '/about-us'
                // }}
                >
                  <NavLink to="/about-us" className="Footer-Section-Item">
                    About Us
                  </NavLink>
                </li>
              </ul>
            </div>

            <div className="Footer-Section">
              <h5 className="Footer-Section-Title underline">Resources</h5>
              <ul className="Footer-Section-List">
                <Link to="/disclaimer" target="_blank" rel="noopener noreferrer">
                  <li className="Footer-Section-Item">Disclaimer</li>
                </Link>
                <Link to="/terms-of-use" target="_blank" rel="noopener noreferrer">
                  <li className="Footer-Section-Item">Terms of Use</li>
                </Link>
                <Link to="/tutor-terms-of-use" target="_blank" rel="noopener noreferrer">
                  <li className="Footer-Section-Item">Tutor Terms of Use</li>
                </Link>
                <Link to="/community-guidelines" target="_blank" rel="noopener noreferrer">
                  <li className="Footer-Section-Item">Community Guidelines</li>
                </Link>
              </ul>
            </div>

            <div className="Footer-Section ">
              <h5 className="Footer-Section-Title underline">Legal</h5>
              <ul className="Footer-Section-List">
                <Link to="/privacy-policy" target="_blank" rel="noopener noreferrer">
                  <li className="Footer-Section-Item">Privacy Policy</li>
                </Link>
                <Link to="/cookie-policy" target="_blank" rel="noopener noreferrer">
                  <li className="Footer-Section-Item">Cookie Policy</li>
                </Link>
                <Link
                  to="/cancellation-and-refund-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <li className="Footer-Section-Item">Cancellation & Refund Policy</li>
                </Link>
                <Link to="/copywriting-policy" target="_blank" rel="noopener noreferrer">
                  <li className="Footer-Section-Item">Copywriting Policy</li>
                </Link>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default LandingFooter
